import { Component } from '@ecs/Component';

export class ParticleDynamics implements Component {
  readonly type = 'ParticleDynamics';

  constructor(
    public drag: number = 0.95, // speed multiplier applied each frame
    public growth: number = 0 // size change per frame (rings and smoke expand)
  ) {}
}
